<!-- src/layouts/default.vue -->
<template>
    <div class="default-layout">
        <Header></Header>
        <div class="main_page">
            <router-view></router-view>
            <GlobalHelpFAB />
        </div>
        <Footer></Footer>
    </div>
</template>
  
<script>
import Header from '../components/fg-header.vue'
import Footer from '../components/fg-footer.vue'
import GlobalHelpFAB from '@/components/GlobalHelpFAB'

export default {
    components: {
        Header,
        Footer,
        GlobalHelpFAB
    }
}
</script>
  
<style scoped>
.default-layout {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

.main_page {
    flex: 1;
    padding: 70px 10px 20px;
}
</style>